/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosClient } from '../helpers/axiosClient';

export const TemplateServices = {

  /* ***======= Company's Template service =======*** */

  // Get all templates
  getTemplates: () => {
    const url = 'api/template';
    return axiosClient.get(url);
  },

  // Get detail templates
  getTemplateById: (id: number) => {
    const url = `api/template/${id}`;
    return axiosClient.get(url);
  },

  // Update template
  updateTemplateById: (payload: {id: number, data: any}) => {
    const url = `api/template/${payload.id}`;
    return axiosClient.patch(url, payload.data);
  },

  // Delete template
  deleteTemplateById: (id: number) => {
    const url = `api/template/${id}`;
    return axiosClient.delete(url);
  },

  /* ***======= Favorites Template service =======*** */

  // Create favorites template
  createFavoriteTemplateById: (payload: {id: number, data: any}) => {
    const url = `api/user-template/create/${payload.id}`;
    return axiosClient.post(url, payload.data);
  },

  // Update template
  updateUserTemplateById: (payload: {id: number, data: any}) => {
    const url = `api/user-template/update/${payload.id}`;
    return axiosClient.patch(url, payload.data);
  },

  // Get all Favorite Templates
  getFavoriteTemplates: () => {
    const url = 'api/user-template/find';
    return axiosClient.get(url);
  },

  // Add template to favorites
  addFavoriteTemplateById: (id: number) => {
    const url = `api/user-template/add-to-user-template/${id}`;
 
    return axiosClient.get(url);
  },

  // Delete template
  deleteFavoriteTemplateById: (id: number) => {
    const url = `api/user-template/remove-from-favorites/${id}`;
    return axiosClient.delete(url);
  },

  // Get detail user template by Id
  getUserTemplateById: (id: number) => {
    const url = `api/user-template/${id}`;
    return axiosClient.get(url);
  },
};
